import React, {PropsWithChildren} from 'react';
import {StyleSheet, View} from 'react-native';
import {colors} from 'src/assets';

export type BottomActionsProps = {};
export const BottomActions: React.FC<
  PropsWithChildren<BottomActionsProps>
> = props => {
  const items = Array.isArray(props.children)
    ? props.children
    : [props.children];
  return (
    <View style={styles.container}>
      {items.map((item, index) => (
        <View key={index} style={styles.item}>
          {item}
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    paddingVertical: 16,
    paddingLeft: 16,
    paddingRight: 8,
    shadowColor: colors.black,
    shadowOffset: {width: 0, height: -2},
    shadowOpacity: 0.1,
    backgroundColor: colors.white,
  },
  item: {
    flex: 1,
    marginRight: 8,
  },
});
